import type * as ents from '@attain-apps/entities'
import _uniq from 'lodash-es/uniq'

import * as color from '../../color'

export function createPalette(
  type?: ents.core.display.chart.Type,
): color.Palette {
  if (type === 'donut') {
    return color.Palette.from(color.Scale.PRIMARY)
  }
  // TODO: get rid of Legacy
  return new color.Palette({ colors: _uniq(color.Legacy.Main.ALL) })
}
